<template>
  <div>
    <p>
      The annual XYPN membership fee paid by this firm is in consideration of a
      variety of services and benefits provided by XYPN to its advisor members -
      including the ability to be listed in this Directory. For a complete
      description of current XYPN member benefits, please refer to the
      <a href="https://www.xyplanningnetwork.com/advisor/member-benefits/"
        >Membership Benefits section</a
      >
      of this website. For current membership pricing, please refer to the
      <a href="https://www.xyplanningnetwork.com/advisor/pricing/"
        >Pricing section</a
      >.
    </p>
    <p>
      XYPN, due to the compensation it receives from advisors in the form of the
      annual membership fee, has an incentive to list only these such advisors
      in the Directory. This creates a material conflict of interest.
    </p>
  </div>
</template>
